(function () {
  'use strict';

  angular.module('app').component('paymentMethodList', paymentMethodList());

  function paymentMethodList() {
    return {
      bindings: {
        paymentMethods: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowPaymentMethod: '&',
      },
      controller: PaymentMethodListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/payment-methods/payment-method-list/payment-method-list.component.html',
    };
  }

  PaymentMethodListComponent.$inject = ['UtilService', 'AbilityService', 'PaymentMethodService'];

  function PaymentMethodListComponent(UtilService, AbilityService, PaymentMethodService) {
    var vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_paymentmethod_accountadmin'),
      canUpdate: AbilityService.can('update_paymentmethod_accountadmin'),
      canDestroy: AbilityService.can('destroy_paymentmethod_accountadmin'),
    };

    vm.UtilService = new UtilService(vm);
    vm.filterCriteria = PaymentMethodService.getFilterCriteria();

    // Methods
    vm.getPaymentMethods = getPaymentMethods;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showPaymentMethod = showPaymentMethod;
    vm.deletePaymentMethod = deletePaymentMethod;
    vm.validateActivatedItems = validateActivatedItems;
    vm.changePaymentMethodStatus = changePaymentMethodStatus;

    function getPaymentMethods() {
      vm.loadingItems = true;
      PaymentMethodService.getPaymentMethods(vm.filterCriteria).then(function () {
        vm.paymentMethods = PaymentMethodService.items;
        vm.meta = PaymentMethodService.meta;

        vm.totalItems = vm.meta.totalItems;
        vm.loadingItems = false;
      });
    }

    function refresh() {
      vm.filterCriteria = PaymentMethodService.getFilterCriteria();
      getPaymentMethods();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      getPaymentMethods();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;

      getPaymentMethods();
    }

    function showPaymentMethod(paymentMethod, mode) {
      if (!vm.permissions.canShow) {
        return;
      }

      vm.onShowPaymentMethod({ item: paymentMethod, mode: mode });
      // PaymentMethodService.openPaymentMethodModal(paymentMethod, mode);
    }

    function changePaymentMethodStatus(paymentMethod) {
      PaymentMethodService.changePaymentMethodStatus(paymentMethod);
    }

    function deletePaymentMethod(paymentMethod) {
      if (paymentMethod.predefined) {
        return;
      }

      PaymentMethodService.deletePaymentMethod(paymentMethod, getPaymentMethods);
    }

    function validateActivatedItems() {
      return vm.paymentMethods.filter((item) => item.status === true).length >= 2;
    }
  }
})();
